import { Controller } from '@hotwired/stimulus';

// Updates the session status card and header icon circle on the vault show
// page when the vault is locked or unlocked — without a full page reload.
export default class extends Controller {
  static targets = ['locked', 'unlocked', 'circle'];

  connect() {
    if (window.vault?.is_open()) {
      this.showUnlocked();
    }
  }

  showUnlocked() {
    this.lockedTarget.classList.add('hidden');
    this.unlockedTarget.classList.remove('hidden');
    if (this.hasCircleTarget) {
      this.circleTarget.classList.remove('bg-warningOrange/15');
      this.circleTarget.classList.add('bg-confirmationLight');
      const lockedIcon = this.circleTarget.querySelector('svg:not(.hidden)');
      if (lockedIcon) {
        lockedIcon.classList.remove('text-warningOrange');
        lockedIcon.classList.add('text-greenProspect');
      }
    }
  }
}
